import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../constants/api';

const BLUE = '#0071e3';

const UserRow = ({ u, i, showCount }) => {
  const relTime = iso => {
    if (!iso) return '';
    const s = Math.floor((Date.now() - new Date(iso)) / 1000);
    if (s < 60) return 'ahora';
    if (s < 3600) return `hace ${Math.floor(s / 60)} min`;
    if (s < 86400) return `hace ${Math.floor(s / 3600)} h`;
    return `hace ${Math.floor(s / 86400)} d`;
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 20px', background: i % 2 === 0 ? 'transparent' : 'rgba(0,0,0,.012)' }}>
      <div style={{ width: 24, height: 24, borderRadius: '50%', background: 'rgba(0,113,227,.07)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <span style={{ fontSize: 10, fontWeight: 600, color: BLUE }}>{(u.name || u.email || '?')[0].toUpperCase()}</span>
      </div>
      <span style={{ fontSize: 12, color: '#1d1d1f', fontWeight: 500, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.name || u.email}</span>
      {showCount && u.login_count > 1 && (
        <span style={{ fontSize: 10, color: '#a1a1a6', flexShrink: 0, whiteSpace: 'nowrap' }}>({u.login_count} veces)</span>
      )}
      <span style={{ fontSize: 11, color: '#a1a1a6', flexShrink: 0 }}>{u.email}</span>
      <span style={{ fontSize: 9, fontWeight: 600, padding: '2px 7px', borderRadius: 100, flexShrink: 0, background: u.plan === 'pro' ? 'rgba(0,113,227,.08)' : 'rgba(0,0,0,.04)', color: u.plan === 'pro' ? BLUE : '#a1a1a6' }}>{u.plan === 'pro' ? 'Pro' : 'Free'}</span>
      <span style={{ fontSize: 11, color: '#a1a1a6', flexShrink: 0, minWidth: 52, textAlign: 'right' }}>{relTime(u.last_seen)}</span>
    </div>
  );
};

const LiveUsersWidget = () => {
  const [data, setData] = useState(null);
  const [bodyOpen, setBodyOpen] = useState(false);
  const [tab, setTab] = useState('now');

  const load = async () => {
    try { const r = await axios.get(`${API}/admin/active-users`); setData(r.data); } catch {}
  };
  useEffect(() => { load(); const id = setInterval(load, 30000); return () => clearInterval(id); }, []);
  if (!data) return null;

  const metrics = [
    { label: '2 min',  value: data.live_2min  },
    { label: '5 min',  value: data.live_5min  },
    { label: '15 min', value: data.live_15min },
    { label: '1 hora', value: data.live_60min },
  ];

  const nowUsers = data.recent_users || [];
  const monthUsers = data.monthly_users || [];
  const monthCount = data.monthly_active_count ?? monthUsers.length;

  const TAB_STYLE = active => ({
    padding: '4px 12px',
    borderRadius: 8,
    border: 'none',
    cursor: 'pointer',
    fontSize: 11,
    fontWeight: 600,
    background: active ? BLUE : 'transparent',
    color: active ? '#fff' : '#a1a1a6',
    transition: 'all .15s',
  });

  return (
    <div style={{ background: '#fff', border: '1px solid rgba(0,0,0,.07)', borderRadius: 18, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,.04)' }}>
      {/* Header — always visible */}
      <div
        onClick={() => setBodyOpen(v => !v)}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 20px', gap: 16, flexWrap: 'wrap', cursor: 'pointer', userSelect: 'none' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ position: 'relative', width: 7, height: 7, flexShrink: 0 }}>
            <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: BLUE, opacity: .3, display: 'block', animation: 'lwRing 2s ease-out infinite' }} />
            <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: BLUE, display: 'block' }} />
          </div>
          <div>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#1d1d1f', letterSpacing: '-.01em' }}>Usuarios activos</span>
            <span style={{ fontSize: 11, color: '#a1a1a6', marginLeft: 6 }}>· actualiza cada 30s</span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
          {metrics.map(({ label, value }, i) => (
            <div key={label} style={{ textAlign: 'center', padding: '0 14px', borderLeft: i > 0 ? '1px solid rgba(0,0,0,.07)' : 'none' }}>
              <div style={{ fontSize: 20, fontWeight: 300, color: BLUE, letterSpacing: '-.04em', lineHeight: 1 }}>{value}</div>
              <div style={{ fontSize: 10, color: '#a1a1a6', marginTop: 2 }}>{label}</div>
            </div>
          ))}
          <div style={{ marginLeft: 16, color: '#a1a1a6', fontSize: 14, lineHeight: 1, transform: bodyOpen ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>▾</div>
        </div>
      </div>

      {/* Collapsible body */}
      {bodyOpen && (
        <div style={{ borderTop: '1px solid rgba(0,0,0,.06)' }}>
          {/* Tabs */}
          <div style={{ display: 'flex', gap: 4, padding: '8px 16px', background: 'rgba(0,0,0,.015)' }}>
            <button style={TAB_STYLE(tab === 'now')} onClick={() => setTab('now')}>
              Ahora ({nowUsers.length})
            </button>
            <button style={TAB_STYLE(tab === 'month')} onClick={() => setTab('month')}>
              Último mes ({monthCount})
            </button>
          </div>

          {/* Now tab */}
          {tab === 'now' && (
            <div style={{ padding: '2px 0 4px' }}>
              {nowUsers.length === 0
                ? <div style={{ padding: '10px 20px', fontSize: 12, color: '#a1a1a6' }}>Sin actividad en los últimos 5 minutos.</div>
                : nowUsers.map((u, i) => <UserRow key={u.id} u={u} i={i} showCount={false} />)
              }
            </div>
          )}

          {/* Month tab */}
          {tab === 'month' && (
            <div style={{ padding: '2px 0 4px', maxHeight: 380, overflowY: 'auto' }}>
              {monthUsers.length === 0
                ? <div style={{ padding: '10px 20px', fontSize: 12, color: '#a1a1a6' }}>Sin actividad en el último mes.</div>
                : monthUsers.map((u, i) => <UserRow key={u.id} u={u} i={i} showCount={true} />)
              }
            </div>
          )}
        </div>
      )}

      <style>{'@keyframes lwRing{0%{transform:scale(1);opacity:.3}100%{transform:scale(2.8);opacity:0}}'}</style>
    </div>
  );
};

const IconRefreshSmall = () => (
  <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </svg>
);

const KPI_ICONS = {
  people: (
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  ),
  eye: (
    <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></>
  ),
  cursor: (
    <path d="M9 3l11 5-5 2-2 5-4-12z" />
  ),
  download: (
    <><path d="M12 3v12" /><path strokeLinecap="round" strokeLinejoin="round" d="M7 10l5 5 5-5" /><path strokeLinecap="round" d="M4 19h16" /></>
  ),
  building: (
    <><rect x="4" y="3" width="16" height="18" rx="1" /><path d="M9 8h1M14 8h1M9 12h1M14 12h1M9 16h1M14 16h1" /></>
  ),
};

const KPI_COLORS = {
  blue: { fg: '#0071e3', bg: 'rgba(0,113,227,.08)' },
  green: { fg: '#34c759', bg: 'rgba(52,199,89,.1)' },
  purple: { fg: '#af52de', bg: 'rgba(175,82,222,.1)' },
  orange: { fg: '#ff9500', bg: 'rgba(255,149,0,.1)' },
  teal: { fg: '#00a3a3', bg: 'rgba(0,163,163,.1)' },
};

const KpiCard = ({ icon, color, label, value, sub }) => {
  const c = KPI_COLORS[color];
  return (
    <div className="bg-white rounded-2xl p-5" style={{ border: '1px solid rgba(0,0,0,.06)' }}>
      <div className="flex items-center gap-3">
        <div
          className="flex items-center justify-center flex-shrink-0"
          style={{ width: 38, height: 38, borderRadius: 11, background: c.bg }}
        >
          <svg width="18" height="18" fill="none" stroke={c.fg} strokeWidth="1.8" viewBox="0 0 24 24">
            {KPI_ICONS[icon]}
          </svg>
        </div>
        <div className="min-w-0">
          <p className="text-xs text-gray-500 truncate" style={{ letterSpacing: '-.01em' }}>{label}</p>
          <p className="text-2xl font-semibold text-gray-900" style={{ letterSpacing: '-.02em' }}>{value}</p>
        </div>
      </div>
      {sub && <p className="text-xs text-gray-400 mt-2" style={{ letterSpacing: '-.01em' }}>{sub}</p>}
    </div>
  );
};

const GlobalAnalyticsTab = () => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAnalytics();
  }, []);

  const loadAnalytics = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/admin/analytics/global`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAnalytics(response.data);
    } catch (error) {
      console.error('Error loading analytics:', error);
      setError('Error al cargar las analíticas');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-300 mx-auto"></div>
        <p className="mt-4 text-gray-600">Cargando analíticas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-900 font-semibold">{error}</p>
        <button
          onClick={loadAnalytics}
          className="mt-4 px-4 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700"
        >
          Reintentar
        </button>
      </div>
    );
  }

  if (!analytics) return null;

  const { totals, recent_activity, click_breakdown, visits_timeline, top_profiles } = analytics;

  const avgVisitsPerProfile = totals.profiles > 0 ? Math.round(totals.visits / totals.profiles) : 0;
  const vcfConversion = totals.visits > 0 ? ((totals.vcf_downloads / totals.visits) * 100).toFixed(1) : 0;
  const engagementRate = totals.visits > 0 ? ((totals.clicks / totals.visits) * 100).toFixed(1) : 0;

  return (
    <div className="space-y-5">
      <LiveUsersWidget />

      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-semibold text-gray-900" style={{ letterSpacing: '-.02em' }}>Analíticas Globales</h2>
          <p className="text-gray-500 text-sm mt-0.5">Resumen del rendimiento de toda la plataforma</p>
        </div>
        <button
          onClick={loadAnalytics}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-white text-gray-600 text-sm rounded-lg hover:bg-gray-50 transition-colors"
          style={{ border: '1px solid rgba(0,0,0,.08)' }}
        >
          <IconRefreshSmall />
          Actualizar
        </button>
      </div>

      {/* KPI cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        <KpiCard
          icon="people" color="blue"
          label="Total Perfiles" value={totals.profiles}
          sub={`${totals.active_profiles} activos · ${totals.inactive_profiles} inactivos`}
        />
        <KpiCard
          icon="eye" color="green"
          label="Total Visitas" value={totals.visits.toLocaleString()}
          sub={`${recent_activity.visits_30d.toLocaleString()} en últimos 30 días`}
        />
        <KpiCard
          icon="cursor" color="purple"
          label="Total Clics" value={totals.clicks.toLocaleString()}
          sub={`${recent_activity.clicks_30d.toLocaleString()} en últimos 30 días`}
        />
        <KpiCard
          icon="download" color="orange"
          label="Descargas VCF" value={totals.vcf_downloads.toLocaleString()}
          sub="Tarjetas de contacto guardadas"
        />
        <KpiCard
          icon="building" color="teal"
          label="Empresas Registradas" value={(totals.companies || 0).toLocaleString()}
          sub="Con datos de empresa completos"
        />
      </div>

      {/* Secondary metrics strip */}
      <div
        className="bg-white rounded-2xl flex flex-wrap"
        style={{ border: '1px solid rgba(0,0,0,.06)' }}
      >
        {[
          { label: 'Usuarios Totales', value: totals.users },
          { label: 'Promedio Visitas/Perfil', value: avgVisitsPerProfile },
          { label: 'Tasa de Conversión VCF', value: `${vcfConversion}%` },
          { label: 'Engagement Rate', value: `${engagementRate}%` },
        ].map((item, i) => (
          <div
            key={item.label}
            className="flex-1 px-5 py-4 text-center"
            style={{ minWidth: 140, borderLeft: i > 0 ? '1px solid rgba(0,0,0,.06)' : 'none' }}
          >
            <p className="text-xs text-gray-500">{item.label}</p>
            <p className="text-lg font-semibold text-gray-900 mt-1" style={{ letterSpacing: '-.02em' }}>{item.value}</p>
          </div>
        ))}
      </div>

      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Visits Timeline */}
        <div className="bg-white rounded-2xl p-5" style={{ border: '1px solid rgba(0,0,0,.06)' }}>
          <h3 className="text-sm font-semibold text-gray-900 mb-4" style={{ letterSpacing: '-.01em' }}>Visitas · Últimos 30 días</h3>
          {visits_timeline && visits_timeline.length > 0 ? (
            <div>
              {(() => {
                const days = visits_timeline.slice(-14);
                const maxCount = Math.max(...days.map(d => d.count), 1);
                const CHART_H = 120;
                return (
                  <div className="flex items-end justify-between gap-1" style={{ height: CHART_H }}>
                    {days.map((day, index) => {
                      const barH = Math.max(Math.round((day.count / maxCount) * CHART_H), day.count > 0 ? 3 : 0);
                      return (
                        <div
                          key={index}
                          className="flex-1 rounded-t hover:opacity-80 transition-opacity cursor-pointer relative group"
                          style={{ height: barH, background: KPI_COLORS.blue.fg }}
                          title={`${day.date}: ${day.count} visitas`}
                        >
                          <span className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                            {day.count}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
              <div className="flex justify-between gap-1 mt-2">
                {visits_timeline.slice(-14).map((day, index) => (
                  <span key={index} className="flex-1 text-center text-xs text-gray-400">
                    {new Date(day.date).getDate()}/{new Date(day.date).getMonth() + 1}
                  </span>
                ))}
              </div>
              <div className="text-center text-xs text-gray-400 mt-4">
                Total: {visits_timeline.reduce((sum, day) => sum + day.count, 0).toLocaleString()} visitas
              </div>
            </div>
          ) : (
            <p className="text-gray-400 text-center py-8 text-sm">No hay datos de visitas</p>
          )}
        </div>

        {/* Click Breakdown */}
        <div className="bg-white rounded-2xl p-5" style={{ border: '1px solid rgba(0,0,0,.06)' }}>
          <h3 className="text-sm font-semibold text-gray-900 mb-4" style={{ letterSpacing: '-.01em' }}>Distribución de Clics</h3>
          {click_breakdown && click_breakdown.length > 0 ? (
            <div className="space-y-3">
              {click_breakdown.map((item, index) => {
                const totalClicks = click_breakdown.reduce((sum, i) => sum + i.count, 0);
                const percentage = ((item.count / totalClicks) * 100).toFixed(1);
                const label = item.type.replace('click_', '').replace(/_/g, ' ');

                return (
                  <div key={index}>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs font-medium text-gray-600 capitalize">{label}</span>
                      <span className="text-xs text-gray-400">{item.count} ({percentage}%)</span>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2">
                      <div
                        className="h-2 rounded-full transition-all duration-500"
                        style={{ width: `${percentage}%`, background: KPI_COLORS.purple.fg }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-gray-400 text-center py-8 text-sm">No hay datos de clics</p>
          )}
        </div>
      </div>

      {/* Top Profiles */}
      <div className="bg-white rounded-2xl p-5" style={{ border: '1px solid rgba(0,0,0,.06)' }}>
        <h3 className="text-sm font-semibold text-gray-900 mb-4" style={{ letterSpacing: '-.01em' }}>Top 10 Perfiles Más Visitados</h3>
        {top_profiles && top_profiles.length > 0 ? (
          <table className="w-full" style={{ tableLayout: 'fixed' }}>
            <colgroup>
              <col style={{ width: '7%' }} />
              <col style={{ width: '28%' }} />
              <col style={{ width: '22%' }} />
              <col style={{ width: '28%' }} />
              <col style={{ width: '15%' }} />
            </colgroup>
            <thead>
              <tr style={{ borderBottom: '1px solid rgba(0,0,0,.06)' }}>
                <th className="py-2 pr-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">#</th>
                <th className="py-2 px-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Perfil</th>
                <th className="py-2 px-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Empresa</th>
                <th className="py-2 px-2 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Visitas</th>
                <th className="py-2 pl-2 text-right text-xs font-medium text-gray-400 uppercase tracking-wider">Enlace</th>
              </tr>
            </thead>
            <tbody>
              {top_profiles.map((profile, index) => (
                <tr key={profile.id} className="hover:bg-gray-50" style={{ borderBottom: '1px solid rgba(0,0,0,.04)' }}>
                  <td className="py-2.5 pr-2">
                    <span
                      className="inline-flex items-center justify-center text-xs font-semibold rounded-full"
                      style={{
                        width: 22, height: 22,
                        background: index < 3 ? KPI_COLORS.blue.bg : 'transparent',
                        color: index < 3 ? KPI_COLORS.blue.fg : '#a1a1a6',
                      }}
                    >
                      {index + 1}
                    </span>
                  </td>
                  <td className="py-2.5 px-2 truncate">
                    <div className="text-sm font-medium text-gray-900 truncate">
                      {profile.name} {profile.lastname}
                    </div>
                  </td>
                  <td className="py-2.5 px-2 text-sm text-gray-500 truncate">
                    {profile.company || '-'}
                  </td>
                  <td className="py-2.5 px-2">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-900 flex-shrink-0">{profile.visits || 0}</span>
                      <div className="flex-1 bg-gray-100 rounded-full h-1.5 min-w-0">
                        <div
                          className="h-1.5 rounded-full"
                          style={{
                            width: `${Math.min((profile.visits / top_profiles[0].visits) * 100, 100)}%`,
                            background: KPI_COLORS.blue.fg,
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  <td className="py-2.5 pl-2 text-right text-sm">
                    <a
                      href={`/pages/${profile.slug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sky-600 hover:text-sky-800"
                      title="Ver perfil"
                    >
                      Ver →
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-gray-400 text-center py-8 text-sm">No hay datos de perfiles</p>
        )}
      </div>
    </div>
  );
};

export default GlobalAnalyticsTab;
